import {
  Button,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tag,
  Typography,
  Upload,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../util/panel";
import moment from "moment";
import { useHttp } from "../../../hooks/http";
import { getToken, URL_API } from "../../../utils";
import axios from "axios";
import SelectProduct from "./component/SelectProduct";

const { Search } = Input;
const limit = 30;

function Index({ form }) {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldValue } = form;

  const [page, setPage] = useState(1);
  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [search, setSearch] = useState("");
  const [editingRecord, setEditingRecord] = useState(null);

  // Modal & Edit State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [fileList, setFileList] = useState([]);

  // Fetch รายการ Lab Test
  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/lab-test/`,
      token: true,
      params: {
        query: search,
        date_from: date_from ? moment(date_from).format("YYYY-MM-DD") : null,
        date_to: date_to ? moment(date_to).format("YYYY-MM-DD") : null,
      },
      initialLoad: true,
    },
    [search, date_from, date_to]
  );


  // เปิด Modal เพิ่มข้อมูลใหม่
  const handleOpenModal = () => {
    setEditingId(null);
    setEditingRecord(null);
    resetFields();
    setFileList([]);
    setIsModalOpen(true);
  };
  const handleEdit = (record) => {
    setEditingId(record.id);
    setEditingRecord(record);

    if (record.result_url) {
      setFileList([
        {
          uid: "-1",
          //  ดึงชื่อไฟล์จริง ถ้าไม่มีค่อยใช้ชื่อ fallback
          name: record.file_name || "รายงานฉบับเต็ม.pdf",
          status: "done",
          url: record.result_url,
        },
      ]);
    } else {
      setFileList([]);
    }

    setIsModalOpen(true);

    setTimeout(() => {
      form.setFieldsValue({
        product_code: {
          key: record.product_code,
          label: `${record.product_code} ${record.product_name_th || record.product_name || ""}`,
        },
        lot_mfg: record.lot_mfg,
        checklist: record.checklist,
        label_claim: record.label_claim,
        lab_result: record.lab_result,
      });
    }, 0);
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "ยืนยันการลบข้อมูล",
      content: "คุณต้องการลบรายการผล Lab Test นี้ใช่หรือไม่ ?",
      okText: "ลบข้อมูล",
      okType: "danger",
      cancelText: "ยกเลิก",
      centered: true,
      onOk: async () => {
        try {
          await axios.delete(`${URL_API}/lab-test/delete/${id}`, {
            headers: { Authorization: "Bearer " + getToken() },
          });
          message.success("ลบข้อมูลสำเร็จเรียบร้อยแล้ว");
          reload();
        } catch (err) {
          console.error("Delete Error:", err);
          message.error("เกิดข้อผิดพลาด ไม่สามารถลบข้อมูลได้");
        }
      },
    });
  };

  const handleCloseModal = () => {
    resetFields();
    setEditingRecord(null);
    setFileList([]);
    setEditingId(null);
    setIsModalOpen(false);
  };

  const handleBeforeUpload = (file) => {
    if (file.type !== "application/pdf") {
      message.error("กรุณาอัปโหลดเฉพาะไฟล์ PDF เท่านั้น");
      return false;
    }
    setFileList([file]); // เก็บไฟล์ใหม่ลง state เพื่อให้ Upload component แสดงชื่อไฟล์ใหม่
    return false; // ระงับการ auto upload
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (err) return;

      if (fileList.length === 0) {
        return Modal.warning({
          title: "แจ้งเตือน",
          content: "กรุณาอัปโหลดไฟล์ รายงานฉบับเต็ม",
          okText: "ตกลง",
          centered: true,
        });
      }
      const fileToUpload = fileList[0]?.originFileObj || fileList[0];
      const file = fileToUpload?.file || fileToUpload;

      // ถ้ามีการเลือกไฟล์ใหม่เข้ามา เช็คประเภทไฟล์
      if (file instanceof File && file.type !== "application/pdf") {
        return message.warning("อัปโหลดได้เฉพาะไฟล์ PDF เท่านั้น");
      }

      setSubmitting(true);
      const productCode = values.product_code?.key || values.product_code;

      const data = new FormData();
      // จะ append file ไปก็ต่อเมื่อเป็นไฟล์ใหม่ (instanceof File)
      if (file instanceof File) {
        data.append("file", file);
      }

      data.append("product_code", productCode);
      data.append("lot_mfg", values.lot_mfg);
      data.append("checklist", values.checklist);
      data.append("label_claim", values.label_claim);
      data.append("lab_result", values.lab_result);
      data.append("status", "PASS");
      data.append("container_name", "operations");

      const isEdit = Boolean(editingId);
      const url = isEdit
        ? `${URL_API}/lab-test/update/${editingId}`
        : `${URL_API}/lab-test/create`;

      axios({
        method: "post",
        url: url,
        headers: {
          Authorization: "Bearer " + getToken(),
        },
        data: data,
      })
        .then(() => {
          message.success(
            isEdit
              ? "แก้ไขข้อมูลผล Lab Test เรียบร้อยแล้ว"
              : "บันทึกข้อมูลผล Lab Test เรียบร้อยแล้ว"
          );
          handleCloseModal();
          reload();
        })
        .catch((error) => {
          console.error("Upload Error:", error.response?.data || error.message);
          message.error(
            error.response?.data?.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูล"
          );
        })
        .finally(() => {
          setSubmitting(false);
        });
    });
  };
  useEffect(() => {
    setPage(1);
  }, [search, date_from, date_to]);

  return (
    <>
      <Panel>
        <PanelHeader>Lab Test สินค้า</PanelHeader>
        <PanelBody>
          <Row gutter={12} type="flex" className="align-items-center mb-3">
            <Col span={8}>
              <Search
                placeholder="ค้นหาจากรหัสสินค้า หรือชื่อสินค้า"
                value={search} // <-- เพิ่ม line นี้เพื่อให้ UI ผูกกับ state search
                onChange={(e) => setSearch(e.target.value)} // <-- เพิ่มเพื่อให้พิมพ์โต้ตอบได้ตามปกติ
                onSearch={(value) => {
                  setSearch(value);
                }}
                allowClear
              />
            </Col>
            <Col span={2} className="text-right">
              <Typography.Text strong className="text-nowrap">
                วันที่เพิ่มข้อมูล
              </Typography.Text>
            </Col>
            <Col span={6}>
              <DatePicker.RangePicker
                className="w-100"
                placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
                format="DD/MM/YYYY"
                value={[date_from, date_to]}
                onChange={(e) => {
                  setSearch("");
                  if (e && e[0] && e[1]) {
                    setDateFrom(moment(e[0], "DD/MM/YYYY"));
                    setDateTo(moment(e[1], "DD/MM/YYYY"));
                  } else {
                    setDateFrom(null);
                    setDateTo(null);
                  }
                }}
              />
            </Col>
            <Col span={8}>
              <Row gutter={8} type="flex" justify="end" className="mb-2 mt-2">
                <Col>
                  <Button
                    className="text-white d-flex align-items-center"
                    type="primary"
                    onClick={handleOpenModal}
                  >
                    <span style={{ fontSize: "22px", marginRight: "6px" }}>+</span> เพิ่มผล Lab Test
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* ================= SECTION TABLE ================= */}
          <Table
            bordered
            size="small"
            dataSource={data?.data?.length > 0 ? data?.data : []}
            rowKey="id"
            loading={loading}
            scroll={{ x: "max-content" }}
            pagination={{
              current: page,
              pageSize: limit,
              total: data?.data?.length,
              showLessItems: false,
              size: "default",
              onChange: (currPage) => setPage(currPage),
            }}
          >
            <Table.Column
              title="#"
              dataIndex="row_id"
              align="center"
              render={(text, record, index) => (page - 1) * limit + index + 1}
            />
            <Table.Column title="รหัสสินค้า" dataIndex="product_code" align="left" />
            <Table.Column title="ชื่อสินค้า" dataIndex="product_name_th" align="left"
              render={(text) => (
                <div style={{ maxWidth: 200, wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
                  {text || "-"}
                </div>
              )} />
            <Table.Column
              title="วันที่เพิ่มข้อมูล"
              width={150}
              dataIndex="create_date"
              align="left"
              render={(text) => (text ? moment(text).format("DD/MM/YYYY HH:mm") : "-")}
            />
            <Table.Column title="วันที่ผลิต" dataIndex="lot_mfg" align="left" width={150} />
            <Table.Column title="รายการตรวจ" dataIndex="checklist" align="left" width={250} // กำหนดความกว้างคอลัมน์เพื่อตัดบรรทัดได้เป๊ะขึ้น
              render={(text) => (
                <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
                  {text || "-"}
                </div>
              )} />
            <Table.Column title="ค่าที่เคลมบนฉลากต่อหน่วยบริโภค" dataIndex="label_claim" align="left" width={250} // กำหนดความกว้างคอลัมน์เพื่อตัดบรรทัดได้เป๊ะขึ้น
              render={(text) => (
                <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
                  {text || "-"}
                </div>
              )} />
            <Table.Column title="ผลตรวจต่อหน่วยบริโภค" dataIndex="lab_result" align="left" width={250} // กำหนดความกว้างคอลัมน์เพื่อตัดบรรทัดได้เป๊ะขึ้น
              render={(text) => (
                <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
                  {text || "-"}
                </div>
              )} />
            <Table.Column
              title="สรุปผล"
              dataIndex="result"
              align="center"
              render={(text) => {
                const resultText = text ? text.toString().trim() : "";
                const isPass = resultText.toUpperCase() === "PASS";
                return isPass ? (
                  <Tag color="green">{resultText}</Tag>
                ) : (
                  <Tag color="red">{resultText}</Tag>
                );
              }}
            />
            <Table.Column
              title="จัดการ"
              key="action"
              align="center"
              render={(text, record) => (
                <Row type="flex" justify="center" gutter={8}>
                  <Col>
                    <Button
                      type="primary"
                      className="d-flex align-items-center"
                      ghost
                      size="small"
                      icon="edit"
                      onClick={() => handleEdit(record)}
                    >
                      แก้ไข
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      className="text-white d-flex align-items-center"
                      type="danger"
                      size="small"
                      icon="delete"
                      onClick={() => handleDelete(record.id)}
                    >
                      ลบ
                    </Button>
                  </Col>
                </Row>
              )}
            />
          </Table>
        </PanelBody>
      </Panel>

      {/* Modal เพิ่ม/แก้ไข */}
      <Modal
        title={editingRecord ? "แก้ไขผล Lab Test" : "เพิ่มผล Lab Test"}
        visible={isModalOpen}
        onCancel={handleCloseModal}
        footer={null}
        destroyOnClose
        width={800}
        style={{ top: 80 }}
      >
        <Form onSubmit={handleSubmit} layout="vertical">
          <Form.Item label="สินค้า" style={{ marginTop: "-16px", marginBottom: "12px" }}>
            {getFieldDecorator("product_code", {
              initialValue: editingRecord
                ? {
                  key: editingRecord.product_code,
                  label: `${editingRecord.product_code} ${editingRecord.product_name_th || editingRecord.product_name || ""}`,
                }
                : undefined,
              rules: [{ required: true, message: "กรุณาเลือกสินค้า" }],
            })(<SelectProduct style={{ marginTop: "-6px" }} />)}
          </Form.Item>

          <Form.Item
            label="วันที่ผลิต"
            style={{ marginBottom: "4px" }}
            extra={
              <div style={{ textAlign: "right", color: "#aaa", fontSize: "12px", marginTop: "2px" }}>
                {`${(form.getFieldValue("lot_mfg") || "").length} / 100`}
              </div>
            }
          >
            {getFieldDecorator("lot_mfg", {
              initialValue: editingRecord ? editingRecord.lot_mfg : undefined,
              rules: [{ required: true, message: "กรุณากรอกวันที่ผลิต" }],
            })(<Input placeholder="วันที่ผลิต" maxLength={100} style={{ marginTop: "-6px" }} />)}
          </Form.Item>

          <Form.Item
            label="รายการตรวจ"
            style={{ marginBottom: "4px" }}
            extra={
              <div style={{ textAlign: "right", color: "#aaa", fontSize: "12px", marginTop: "2px" }}>
                {`${(form.getFieldValue("checklist") || "").length} / 200`}
              </div>
            }
          >
            {getFieldDecorator("checklist", {
              initialValue: editingRecord ? editingRecord.checklist : undefined,
              rules: [{ required: true, message: "กรุณากรอกรายการตรวจ" }],
            })(<Input.TextArea placeholder="ระบุรายการตรวจ" maxLength={200} style={{ marginTop: "-6px" }} />)}
          </Form.Item>

          <Form.Item
            label="ค่าที่เคลมบนฉลากต่อหน่วยบริโภค"
            style={{ marginBottom: "4px" }}
            extra={
              <div style={{ textAlign: "right", color: "#aaa", fontSize: "12px", marginTop: "2px" }}>
                {`${(form.getFieldValue("label_claim") || "").length} / 100`}
              </div>
            }
          >
            {getFieldDecorator("label_claim", {
              initialValue: editingRecord ? editingRecord.label_claim : undefined,
              rules: [{ required: true, message: "กรุณากรอกค่าที่เคลม" }],
            })(<Input.TextArea placeholder="ระบุค่าที่เคลมบนฉลาก" maxLength={100} style={{ marginTop: "-6px" }} />)}
          </Form.Item>

          <Form.Item
            label="ผลตรวจต่อหน่วยบริโภค"
            style={{ marginBottom: "4px" }}
            extra={
              <div style={{ textAlign: "right", color: "#aaa", fontSize: "12px", marginTop: "2px" }}>
                {`${(form.getFieldValue("lab_result") || "").length} / 100`}
              </div>
            }
          >
            {getFieldDecorator("lab_result", {
              initialValue: editingRecord ? editingRecord.lab_result : undefined,
              rules: [{ required: true, message: "กรุณากรอกผลตรวจ" }],
            })(<Input.TextArea placeholder="ระบุผลตรวจ" maxLength={100} style={{ marginTop: "-6px" }} />)}
          </Form.Item>

          <Form.Item label="ไฟล์รายงานฉบับเต็ม" required style={{ marginBottom: "12px" }}>
            <Upload
              fileList={fileList}
              beforeUpload={handleBeforeUpload}
              onRemove={() => setFileList([])}
              accept=".pdf"
            >
              <Button icon="upload">อัปโหลดไฟล์ PDF</Button>
            </Upload>
          </Form.Item>

          <Row type="flex" justify="end" gutter={8} style={{ marginTop: "12px" }}>
            <Col>
              <Button onClick={handleCloseModal} disabled={submitting}>
                ยกเลิก
              </Button>
            </Col>
            <Col>
              <Button type="primary" htmlType="submit" loading={submitting}>
                บันทึก
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default Form.create()(Index);